import { motion, Variants, Easing } from "framer-motion";
import domesticImage from "../../Images/domesticImg2.jpg";
import commercialImage from "../../Images/commercialImg2.jpg";
import conservatoryRoofImage from "../../Images/conservatoryCleaning1.jpg";
import gutterCleaningImage from "../../Images/gutterCleaningImg1.jpg";
import Section from "../Common/Section";
import "./style.scss";

interface OurServicesDetailsProps {
  order?: "odd" | "even";
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" as Easing },
  },
};

const OurServicesDetails: React.FC<OurServicesDetailsProps> = ({ order }) => {
  return (
    <Section variant={order} className="ourServicesDetails">
      <motion.div className="sectionHeader" variants={itemVariants}>
        <h2 className="title">Premium Cleaning Services</h2>
        <p className="description">
          Professional window and exterior cleaning solutions for your home and
          business
        </p>
      </motion.div>

      <motion.div
        id="DomesticWindows"
        className="serviceSection"
        variants={itemVariants}
      >
        <div className="serviceContent">
          <div className="imageArea">
            <img
              className="detailsImg"
              src={domesticImage}
              alt="Domestic Window Cleaning"
            />
          </div>
          <div className="textArea">
            <p className="category">Residential</p>
            <h3 className="heading">Domestic Window Cleaning</h3>
            <p className="description">
              With over 50 years in the Window Cleaning industry, we specialise
              in Domestic Window Cleaning, bringing a sparkle to your homes. Our
              equipment allows us to give you a streak-free finish to windows
              which you'll love.
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        id="CommercialWindows"
        className="serviceSection alt"
        variants={itemVariants}
      >
        <div className="serviceContent">
          <div className="imageArea">
            <img
              className="detailsImg"
              src={commercialImage}
              alt="Commercial Window Cleaning"
            />
          </div>
          <div className="textArea">
            <p className="category">Business</p>
            <h3 className="heading">Commercial Window Cleaning</h3>
            <p className="description">
              We can offer Commercial Window Cleaning to meet all window
              cleaning issues in the area. If your business needs any window
              cleaning services, be sure to contact us. We can even offer early
              morning, off-hours work, if it would be more beneficial for your
              business.
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        id="ConservatoryRoofs"
        className="serviceSection"
        variants={itemVariants}
      >
        <div className="serviceContent">
          <div className="imageArea">
            <img
              className="detailsImg"
              src={conservatoryRoofImage}
              alt="Conservatory Roof Cleaning"
            />
          </div>
          <div className="textArea">
            <p className="category">Specialist</p>
            <h3 className="heading">Conservatory Roof Cleaning</h3>
            <p className="description">
              We also offer conservatory cleaning services, ensuring your
              conservatory is sparkling clean. Whether it's the glass roof or
              the hard-to-reach corners, we'll deliver a spotless finish,
              letting you enjoy a cleaner, brighter space all year round.
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        id="GutterCleaning"
        className="serviceSection alt"
        variants={itemVariants}
      >
        <div className="serviceContent">
          <div className="imageArea">
            <img
              className="detailsImg"
              src={gutterCleaningImage}
              alt="Gutter Cleaning"
            />
          </div>
          <div className="textArea">
            <p className="category">Maintenance</p>
            <h3 className="heading">Gutter Cleaning</h3>
            <p className="description">
              We also provide gutter cleaning services to keep your home
              protected from blockages and water damage. We remove debris,
              leaves, and dirt to ensure your gutters are clear and functioning
              properly, maintaining the integrity of your property.
            </p>
          </div>
        </div>
      </motion.div>
    </Section>
  );
};

export default OurServicesDetails;
